import React from 'react';
import { useLocation } from 'react-router-dom';

function ScrollAndFocusHelper() {
    const location = useLocation();

    const scrollContainersToTop = React.useCallback((behavior = 'auto') => {
        try {
            const root = document.getElementById('root');
            const main = document.querySelector('main');
            const app = document.querySelector('#app');
            const scrollingElement = document.scrollingElement || document.documentElement;

            // Try window first
            if (typeof window.scrollTo === 'function') {
                window.scrollTo({ top: 0, behavior });
            }

            // Then typical elements that may own scroll
            [scrollingElement, document.documentElement, document.body, root, main, app]
                .filter(Boolean)
                .forEach((el) => {
                    try {
                        el.scrollTop = 0;
                    } catch (_) {}
                });
        } catch (_) {}
    }, []);

    React.useEffect(() => {
        const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        // If there is a hash, attempt to scroll to that element. Retry if not yet mounted.
        if (location.hash) {
            const id = location.hash.replace('#', '');
            const tryScrollToHash = (attempt = 0) => {
                const el = document.getElementById(id);
                if (el) {
                    el.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' });
                    if (el.hasAttribute('data-autofocus')) {
                        const focusable = el.querySelector('input, textarea, select, [tabindex]');
                        (focusable || el).focus?.();
                    }
                    return true;
                }
                if (attempt < 3) {
                    // Retry after next paint and short timeout to allow content to mount
                    requestAnimationFrame(() => setTimeout(() => tryScrollToHash(attempt + 1), 60));
                } else {
                    // Fallback to top if element never appears
                    scrollContainersToTop(prefersReducedMotion ? 'auto' : 'smooth');
                }
                return false;
            };
            tryScrollToHash();
            return;
        }

        // Default: scroll to top on route change after paint
        requestAnimationFrame(() => scrollContainersToTop(prefersReducedMotion ? 'auto' : 'smooth'));
        // Also enforce once more after a brief delay to handle late content height changes/route transitions
        setTimeout(() => scrollContainersToTop('auto'), 120);
    }, [location.pathname, location.hash, location.search, scrollContainersToTop]);

    return null;
}

export default ScrollAndFocusHelper;


